import moment from "moment";

export default {
    state : {
        url: '/api/hms/inspections/list',
        errors: {},
        inspections: [],
        inspection: [],
        inspection_id: null,
        files: [],
        form: {
            type: 'initial',
            facility_id: '',
            date: null,
            cap_due: null,
            inspected_areas: '',
            contents: [],
            notes: '',
            status: false,
        },
        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'date', label: 'Date', sortable: true, tdClass: 'text-muted'},
                {key: 'type', label: 'Type', tdClass: 'text-muted'},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'inspected_areas', label: 'Total Areas', sortable: true, tdClass: 'text-muted'},
                {key: 'cap_due', label: 'CAP Due', sortable: true, tdClass: 'text-muted'},
                {key: 'inspector', label: 'Inspector', tdClass: 'text-muted'},
                {key: 'status', label: 'Status', sortable: true, tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions'},
            ]
        }
    },

    getters: {
        getInspectionTableFields: state => state.table.fields,

        getInspectionFiles: state => state.files,

        getInspectionForm: state => state.form,

        getInspectionsMeta: state => state.meta,

        getInspectionErrors: state => state.errors,

        getInspection: state => state.inspection,
    },

    mutations: {
        setInspections: (state, payload) => {
            state.inspections = payload;
        },

        setInspection: (state, payload) => {
            state.inspection_id = payload.inspection_id;
            state.inspection = payload;
        },

        setInspectionFiles: (state, payload) => {
            state.files = payload;
        },

        setInspectionsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setInspectionErrors: (state, payload) => {
            state.errors = payload;
        },

        setInspectionForm: state => {
            state.form = {
                type: 'initial',
                facility_id: '',
                date: null,
                cap_due: null,
                inspected_areas: '',
                contents: [],
                notes: '',
                status: false,
            };

            state.errors = {};
        },

        resetInspectionsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setFollowupForm: (state, payload) => {
            state.form = payload;
        },
    },

    actions: {
        fetchInspections: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setInspections', response.data);

                        commit('setInspectionsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setInspectionErrors', error.response.data.errors);

                        reject(error);
                    });
            });
        },

        fetchInspectionFiles: ({state, commit}, inspection_id) => {
            return new Promise((resolve, reject) => {
                axios.get('/api/hms/inspections/' + inspection_id + '/attachments')
                    .then(response => {
                        commit('setInspectionFiles', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitInspection: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setInspectionErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        fetchEditInspection: ({state, commit}, inspection_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + inspection_id + '/edit')
                    .then(response => {
                        state.inspection_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchFollowupForm: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                if (payload) {
                    commit('setFollowupForm', payload);
                    resolve(payload);
                } else {
                    reject();
                }
            });
        },

        followupInspection: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url + '/' + payload.id + '/followup', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setInspectionErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        updateInspection: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.inspection_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setInspectionErrors', error.response.data.errors);

                        reject(error);
                    });
            })
        },

        deleteInspection: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.inspection_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

        fetchInspection: ({state, commit}, inspection_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + inspection_id)
                    .then(response => {
                        commit('setInspection', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
    }
}
